<template>
  <b-modal
    id="view_bed"
    no-close-on-backdrop
    hide-footer
    modal-class="modern-modal"
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <template v-slot:modal-title>
      <div class="modal-title-modern">
        <i class="fas fa-edit mr-2"></i>
        Editar Leito
      </div>
    </template>

    <div class="modal-content-modern">
      <b-form @submit.prevent="evOnSubmit">
        <div class="form-grid">
          <!-- Número -->
          <div class="form-group">
            <label-required-field label="Número" />
            <input
              ref="autofocus"
              v-model="number"
              type="text"
              class="modern-form-input"
              placeholder="Digite o número do leito"
            />
          </div>

          <!-- Andar -->
          <div class="form-group">
            <label class="form-label">Andar</label>
            <input
              v-model="walk"
              type="text"
              class="modern-form-input"
              placeholder="Digite o andar"
            />
          </div>

          <!-- Ala/Setor -->
          <div class="form-group full-width">
            <label class="form-label">Ala/Setor</label>
            <input
              v-model="ward_or_sector"
              type="text"
              class="modern-form-input"
              placeholder="Digite a ala ou setor"
            />
          </div>

          <!-- Quarto -->
          <div class="form-group full-width">
            <label class="form-label">Quarto</label>
            <input
              v-model="bedroom"
              type="text"
              class="modern-form-input"
              placeholder="Digite o quarto"
            />
          </div>
        </div>

        <!-- Metadata -->
        <div v-if="bed" class="metadata-section">
          <div class="metadata-card">
            <div class="metadata-item">
              <i class="fas fa-calendar-plus metadata-icon"></i>
              <div class="metadata-content">
                <span class="metadata-label">Criação</span>
                <span class="metadata-value">{{
                  formatDate(bed.created_at)
                }}</span>
              </div>
            </div>
            <div class="metadata-item">
              <i class="fas fa-edit metadata-icon"></i>
              <div class="metadata-content">
                <span class="metadata-label">Última alteração</span>
                <span class="metadata-value">{{
                  formatDate(bed.updated_at)
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Warning and Errors -->
        <div class="form-footer">
          <warning-required-fields />
          <errors-messages :errors="errors" />

          <div class="form-actions">
            <v-btn
              :disabled="loading"
              class="btn-cancel-modern"
              @click="$bvModal.hide('view_bed')"
            >
              <i class="fas fa-times mr-2"></i>
              Cancelar
            </v-btn>
            <v-btn
              :disabled="loading"
              class="btn-delete-modern"
              @click="remove"
            >
              <i class="fas fa-trash mr-2"></i>
              {{ loading ? "Excluindo..." : "Excluir" }}
            </v-btn>
            <v-btn :disabled="loading" type="submit" class="btn-save-modern">
              <i class="fas fa-save mr-2"></i>
              {{ loading ? "Salvando..." : "Salvar" }}
            </v-btn>
          </div>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import permission from "../../lib/permission";
import { formatDate } from "../../lib/format";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields.vue";

export default {
  name: "ViewBed",

  components: {
    LabelRequiredField,
    WarningRequiredFields,
    ErrorsMessages,
  },

  props: {
    bed: Object,
  },

  data() {
    return {
      errors: [],
      loading: false,

      number: "",
      walk: "",
      ward_or_sector: "",
      bedroom: "",
    };
  },

  watch: {
    async bed(value) {
      if (!value) return;

      this.number = value.number;
      this.walk = value.walk;
      this.ward_or_sector = value.ward_or_sector;
      this.bedroom = value.bedroom;

      this.$bvModal.show("view_bed");
    },
  },

  methods: {
    permission,
    formatDate,

    async evOnShow() {
      this.errors = [];
      this.loading = false;
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        this.errors = [];

        if (this.number.length > 50)
          this.errors.push("Informe até 50 caracteres no campo Nº");

        if (this.walk.length > 50)
          this.errors.push("Informe até 50 caracteres no campo Andar");

        if (this.ward_or_sector.length > 50) {
          this.errors.push("Informe até 50 caracteres no campo Ala/Setor");
        }

        if (this.bedroom.length > 50)
          this.errors.push("Informe até 50 caracteres no campo Quarto");

        if (this.errors.length > 0) {
          this.loading = false;
          return;
        }

        const data = {
          id: this.bed.id,
          number: this.number,
          walk: this.walk,
          ward_or_sector: this.ward_or_sector,
          bedroom: this.bedroom,
        };
        const response = await api.put("/rest-home/bed/update", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("view_bed");
          toast(message, "success");
          this.$emit("updated");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async remove() {
      try {
        this.loading = true;

        const data = { id: this.bed.id };
        const response = await api.delete("/rest-home/bed/delete", { data });
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("view_bed");
          toast(message, "success");
          this.$emit("updated");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-content-modern {
  padding: 8px 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.modern-form-input {
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  background: white !important;
}

.modern-form-input:focus {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
  outline: none !important;
}

/* Metadata Section */
.metadata-section {
  margin-bottom: 24px;
}

.metadata-card {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.metadata-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.metadata-icon {
  color: #1e40af;
}

.metadata-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.metadata-label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.metadata-value {
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
}

.form-footer {
  border-top: 1px solid #e5e7eb;
  padding-top: 24px;
  margin-top: 24px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}

.btn-cancel-modern {
  background: white !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.btn-cancel-modern:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
}

.btn-delete-modern {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-delete-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4) !important;
}

.btn-save-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-save-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4) !important;
}

.btn-save-modern:disabled,
.btn-delete-modern:disabled,
.btn-cancel-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .metadata-card {
    padding: 12px;
  }

  .form-actions {
    flex-direction: column;
    gap: 8px;
  }

  .btn-cancel-modern,
  .btn-delete-modern,
  .btn-save-modern {
    width: 100%;
  }
}
</style>